import classNames from "classnames";
import React, { useEffect } from "react";
import { Image as ImageComp, initCustomElement } from "./../../bundled-dependencies/wix-image";
import styles from "./Image-scss";
import MediaItemErrorMsg from "./MediaItemErrorMsg";
let wixImageInitialized = false;
const Image = (props) => {
  if (!wixImageInitialized) {
    initCustomElement();
    wixImageInitialized = true;
  }
  const { containerProps, error, ...imageProps } = props;
  const [shouldUseLQIP, setShouldUseLQIP] = React.useState(true);
  useEffect(() => {
    const handleBeforePrint = () => {
      setShouldUseLQIP(false);
    };
    window.addEventListener("beforeprint", handleBeforePrint);
    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
    };
  }, []);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: containerProps?.style,
      id: containerProps?.containerId,
      className: containerProps?.className,
      "data-hook": containerProps?.dataHook
    },
    /* @__PURE__ */ React.createElement(
      ImageComp,
      {
        ...imageProps,
        className: classNames(styles.image, imageProps.className),
        shouldUseLQIP
      }
    ),
    error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error: error.message, t: error.t })
  );
};
var Image_default = Image;
export {
  Image_default as default
};
//# sourceMappingURL=Image.js.map
